import * as React from "react";
import { BaseComponent, Trad } from "../components/";
import * as Dati from "../Dati";
import * as Glob from "../Globale";

export enum CopyType {
    Branch = "ID_TipoRamo",
    Product = "ID_TipoProdotto",
    Company = "ID_BinderCompagnia",
    EmptyFields = ""
}

interface ICommissionDataProps extends Dati.IBaseProps {
    Valore: string;
    OnCopyValues: (type: CopyType) => any;
}

export class CommissionData extends BaseComponent<ICommissionDataProps, {}> {
    private _Data: Array<any> = [];

    public constructor(props: any) {
        super(props);
        this.OnChange = this.OnChange.bind(this);
    }

    private Inizializza() {
        if (this.props.Valore != "{}") {
            this._Data = JSON.parse(this.props.Valore);
        }
    }

    protected OnChange(e: React.FormEvent<any>): void {
        this._Data = this._Data.map(item => {
            if (Object.keys(item.Parametri)[0] == e.currentTarget.name) {
                item.Parametri[e.currentTarget.name] = e.currentTarget.value;
            }
            return item;
        });
        this.props.OnChange(this.props.Name, JSON.stringify(this._Data));
    }

    public render() {
        this.Inizializza();

        return (
            <div>
                <label>{Trad.Trad("Provvigioni")}</label>
                <div className="dropdown dropdown-inline dropleft kt-pull-right">
                    <button type="button" className="btn btn-default btn-icon btn-sm btn-icon-md" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="flaticon2-copy" />
                    </button>
                    <div className="dropdown-menu dropdown-menu-right" x-placement="left-start">
                        <a
                            className="dropdown-item"
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                this.props.OnCopyValues(CopyType.Branch);
                            }}
                        >
                            {Trad.Trad("Copy values")}
                        </a>
                        <a
                            className="dropdown-item"
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                this.props.OnCopyValues(CopyType.EmptyFields);
                            }}
                        >
                            {Trad.Trad("Copy to empty fields")}
                        </a>
                        <a
                            className="dropdown-item"
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                this.props.OnCopyValues(CopyType.Product);
                            }}
                        >
                            {Trad.Trad("Copy to the same product")}
                        </a>
                        <a
                            className="dropdown-item"
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                this.props.OnCopyValues(CopyType.Company);
                            }}
                        >
                            {Trad.Trad("Copy on the same company")}
                        </a>
                    </div>
                </div>
                {this._Data.map((item, index) => {
                    const commissionType = Object.keys(item.Parametri)[0];

                    return (
                        <div className="form-group kt-form login-form__group row" key={index}>
                            <div className={Glob.DimensioneCSS(3)}>
                                <label>{Trad.Trad(commissionType)}</label>
                                <input
                                    className="form-control kt-input kt-input--solid"
                                    value={item.Parametri[commissionType]}
                                    type="number"
                                    min="1"
                                    max="99"
                                    onChange={this.OnChange}
                                    placeholder={Trad.Trad(commissionType)}
                                    name={commissionType}
                                    required
                                />
                            </div>
                            <div className={Glob.DimensioneCSS(3)}>
                                <label>{Trad.Trad("Commission Calculation Method")}</label>
                                <select name="Funzione" className="form-control kt-input" defaultValue={item.Funzione}>
                                    <option value={item.Funzione}>{Trad.Trad(item.Funzione)}</option>
                                </select>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CommissionData.tsx